/*
 * Mooncorn — Koleksiyon "tükenenler en sonda" (GLOBAL) + hibrit "Daha fazla yükle"
 * ---------------------------------------------------------------------------------
 * Sunucu HAFİF/SAYFALI render eder (no-JS güvenli fallback: her sayfa kendi içinde
 * stoklu->tükenen). Bu betik koleksiyonun TÜM sayfalarını Section Rendering API ile
 * çeker, varyant kartlarını GLOBAL sıralar (stoklular önce, tükenenler EN SONDA) ve
 * parça parça gösterir:
 *   • İlk AUTO_BATCHES parti KAYDIRINCA otomatik (kesintisiz akış).
 *   • Sonra "Daha fazla yükle" butonu (DOM sınırlı, footer ulaşılır).
 *
 * Güvenlik (adversaryal incelemeden sonra sertleştirildi):
 *  - enhance() en başında KOŞULSUZ: token++ , önceki fetch abort, scroll dinleyici teardown.
 *  - Sayfalama (pagination) YALNIZ başarıda gizlenir; fetch ÖNCESİ asla. Her fetch'te timeout.
 *  - totalPages > MAX_PAGES ise hiç dokunma (sunucu sayfalaması görünür kalsın -> ürün kaybolmaz).
 *  - Stale paint/catch token korumalı. Erişilebilirlik: odak yönetimi + aria-live + güvenli skip hedefi.
 *  - Herhangi bir hata/eksik -> sunucunun sayfalı görünümüne DOKUNMAZ.
 */
(function () {
  'use strict';

  var CHUNK = 24;            // her partide eklenecek kart
  var AUTO_BATCHES = 3;      // ilk N parti (~72 kart) kaydırınca otomatik, sonra buton
  var PRELOAD_PX = 800;      // dibe bu kadar yaklaşınca sonraki parti
  var MAX_PAGES = 80;        // bu üstündeyse enhance ETME (sunucu sayfalaması kalsın -> ürün kaybolmaz)
  var CONCURRENCY = 4;       // paralel sayfa çekme
  var FETCH_TIMEOUT_MS = 10000;
  var RETRY = 1;             // sayfa başına yeniden deneme
  var DEBOUNCE_MS = 200;     // theme:navigation:reloaded debounce
  var runToken = 0;
  var aborter = null;
  var liveRegion = null;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function isOOS(card) { return !!card.querySelector('.product--label[data-label-type="out-of-stock"]'); }
  function gridEl() { return document.querySelector('[data-body-grid]'); }
  function paginationEl() { return document.querySelector('[data-body-pagination]'); }
  function loadMoreEl(grid) { return grid.parentNode.querySelector('[data-oos-loadmore]'); }
  function sectionId() { var r = document.querySelector('[data-section-type="collection"]'); return r ? r.getAttribute('data-section-id') : ''; }
  function viewportH() { return window.innerHeight || document.documentElement.clientHeight || 0; }

  function announce(msg) {
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('role', 'status');
      liveRegion.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;';
      document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = msg;
  }

  // timeout + kullanıcı-abort birleşik sinyali (desteklenmeyen tarayıcıda yalnız parent -> timeout yok, kabul)
  function fetchSignal(parent) {
    try {
      if (AbortSignal.timeout && AbortSignal.any) {
        return parent ? AbortSignal.any([parent, AbortSignal.timeout(FETCH_TIMEOUT_MS)]) : AbortSignal.timeout(FETCH_TIMEOUT_MS);
      }
    } catch (e) {}
    return parent;
  }

  function cardsFromHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var grid = doc.querySelector('[data-body-grid]');
    if (!grid) return [];
    var nodes = Array.prototype.slice.call(grid.querySelectorAll('.product-card--root'));
    // adoptNode -> kartları canlı belgeye taşı, parse belgesini serbest bırak (bellek)
    return nodes.map(function (n) { try { return document.adoptNode(n); } catch (e) { return n; } });
  }

  function pageUrl(page, sid) {
    var params = new URLSearchParams(window.location.search); // aktif filtre/sıralama
    params.delete('page'); params.delete('section_id');
    params.set('page', String(page));
    if (sid) params.set('section_id', sid);
    return window.location.pathname + '?' + params.toString();
  }

  async function fetchPage(url, parentSignal) {
    for (var attempt = 0; attempt <= RETRY; attempt++) {
      try {
        var r = await fetch(url, { credentials: 'same-origin', signal: fetchSignal(parentSignal) });
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return cardsFromHtml(await r.text());
      } catch (e) {
        if (parentSignal && parentSignal.aborted) throw e;   // kullanıcı filtreledi/gitti
        if (attempt === RETRY) throw e;                       // son deneme de düştü -> fallback
        await sleep(300 * (attempt + 1));                     // backoff (429/stall toleransı)
      }
    }
  }

  // Herhangi bir sayfa kalıcı düşerse TÜMÜ reddet -> fallback (sunucu sayfalaması = tüm ürünler erişilir).
  async function fetchAllCards(totalPages, sid, signal) {
    var pages = [];
    for (var p = 1; p <= totalPages; p++) pages.push(p);
    var out = new Array(pages.length);
    var next = 0;
    async function worker() {
      while (next < pages.length) {
        var my = next++;
        out[my] = await fetchPage(pageUrl(pages[my], sid), signal);
      }
    }
    var pool = [];
    for (var c = 0; c < Math.min(CONCURRENCY, pages.length); c++) pool.push(worker());
    await Promise.all(pool);
    var all = [];
    out.forEach(function (arr) { all = all.concat(arr || []); });
    return all;
  }

  function globalSort(cards) {
    var inStock = [], soldOut = [];
    cards.forEach(function (c) { (isOOS(c) ? soldOut : inStock).push(c); });
    return inStock.concat(soldOut);
  }

  function render(grid, ordered, myToken) {
    grid.removeAttribute('data-transition-container'); // O(n^2) cascade'i kapat (donma önleme)
    grid.setAttribute('aria-hidden', 'false');
    grid.innerHTML = '';

    var columns = parseInt(grid.getAttribute('data-columns') || '3', 10) || 3;
    var shown = 0, painted = 0;
    var wrap = loadMoreEl(grid);
    var btn = wrap ? wrap.querySelector('button') : null;

    var sentinel = null;
    if (wrap) {
      sentinel = wrap.parentNode.querySelector('[data-oos-sentinel]');
      if (!sentinel) {
        sentinel = document.createElement('div');
        sentinel.setAttribute('data-oos-sentinel', '');
        sentinel.setAttribute('aria-hidden', 'true');
        sentinel.style.height = '1px';
        wrap.parentNode.insertBefore(sentinel, wrap);
      }
      sentinel.style.display = '';
    }
    var autoEnabled = !!sentinel;
    var ticking = false;

    function teardownScroll() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }
    function autoCheck() {
      if (myToken !== runToken) { teardownScroll(); return; }       // stale -> no-op
      if (!autoEnabled || painted >= AUTO_BATCHES || shown >= ordered.length || !sentinel) return;
      if (sentinel.getBoundingClientRect().top <= viewportH() + PRELOAD_PX) paint(false);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      setTimeout(function () { ticking = false; autoCheck(); }, 100); // rAF DEĞİL (arka planda durur)
    }

    function updateControls() {
      var more = shown < ordered.length;
      if (!wrap) return;
      if (!more) { wrap.hidden = true; if (sentinel) sentinel.style.display = 'none'; teardownScroll(); return; }
      if (autoEnabled && painted < AUTO_BATCHES) { wrap.hidden = true; }
      else { wrap.hidden = false; if (btn) btn.disabled = false; if (sentinel) sentinel.style.display = 'none'; teardownScroll(); }
    }

    function paint(viaButton) {
      if (myToken !== runToken) return;          // stale handler -> no-op
      var frag = document.createDocumentFragment();
      var firstNew = null;
      var end = Math.min(shown + CHUNK, ordered.length);
      for (var i = shown; i < end; i++) {
        var card = ordered[i];
        card.removeAttribute('data-transition-item'); // opacity:0'da kalmasın
        card.removeAttribute('aria-hidden');
        // İlk partinin ilk satırı hariç tüm görseller lazy (yeniden sıralamada eager dağılmasın)
        if (!(painted === 0 && i < columns)) {
          var imgs = card.querySelectorAll('img');
          for (var k = 0; k < imgs.length; k++) imgs[k].setAttribute('loading', 'lazy');
        }
        if (firstNew === null) firstNew = card;
        frag.appendChild(card);
      }
      grid.appendChild(frag);
      shown = end;
      painted++;
      updateControls();
      announce(shown + ' / ' + ordered.length + ' ürün gösteriliyor');
      // Butonla yüklemede: odağı ilk yeni karta taşı (klavye/SR konumu kaybolmasın)
      if (viaButton && firstNew) {
        var link = firstNew.querySelector('a');
        var target = link || firstNew;
        try { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); } catch (e) {}
      }
    }

    paint(false); // ilk parti

    if (autoEnabled) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      grid.__oosTeardown = teardownScroll;
      setTimeout(autoCheck, 0); // başta zaten dibe yakınsa (kısa liste)
    }
    if (btn) btn.onclick = function () { paint(true); };
  }

  function enhance() {
    var grid = gridEl();
    if (!grid) return;

    // --- STALENESS BOOKKEEPING: KOŞULSUZ, en başta (filtre-çalma yarışını ve dinleyici sızıntısını önler) ---
    var token = ++runToken;
    if (aborter) { try { aborter.abort(); } catch (e) {} aborter = null; }
    if (grid.__oosTeardown) { try { grid.__oosTeardown(); } catch (e) {} grid.__oosTeardown = null; }

    var pag = paginationEl();
    if (pag) pag.style.display = '';   // fetch boyunca GÖRÜNÜR (yalnız başarıda gizlenecek -> dead-end yok)

    var meta = grid.querySelector('[data-oos-total-pages]');
    var totalPages = meta ? parseInt(meta.getAttribute('data-oos-total-pages') || '1', 10) : 1;
    var wrap = loadMoreEl(grid);

    // Tek sayfa: sunucu zaten doğru & hafif. Çok büyük (>MAX_PAGES): dokunma -> tüm ürünler sayfalamayla erişilir.
    if (!totalPages || totalPages <= 1 || totalPages > MAX_PAGES) {
      if (wrap) wrap.hidden = true;
      return;
    }

    aborter = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var sid = sectionId();

    fetchAllCards(totalPages, sid, aborter ? aborter.signal : undefined)
      .then(function (cards) {
        if (token !== runToken) return;          // daha yeni filtre/sıralama geldi
        if (!cards || !cards.length) return;     // eksik -> sunucu sayfalı görünümü kalsın (pag görünür)
        var pg = paginationEl();
        if (pg) pg.style.display = 'none';        // YALNIZ başarıda gizle
        render(grid, globalSort(cards), token);
      })
      .catch(function (e) {
        if (token !== runToken) return;          // catch token-korumalı
        // pagination hiç gizlenmedi -> sunucu sayfalı görünümü zaten erişilebilir, geri-alma gerekmez
      });
  }

  var debounceTimer = null;
  function enhanceDebounced() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { try { enhance(); } catch (e) {} }, DEBOUNCE_MS);
  }

  ready(function () {
    if (!gridEl()) return;
    try { enhance(); } catch (e) {}
    window.addEventListener('theme:navigation:reloaded', enhanceDebounced); // filtre/sıralama sonrası
  });
})();
